import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { contentBlockShadow } from '../../../../theme';
import { track } from '../../analytics';

/**
 * Trainer contact banner pointing pet parents at the in-app Messages section
 * (replaces the old text/email CTAs to keep support in-product and cut SMS costs).
 */
function TrainerContactBanner() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        borderRadius: '12px',
        boxShadow: contentBlockShadow,
        p: { xs: 2.5, md: '22px 28px' },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        gap: { xs: 2, md: 3.5 },
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ maxWidth: 760 }}>
        <Typography variant="h5">Have a question for a trainer?</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1, lineHeight: 1.5 }}>
          Send a message and we&apos;ll respond within 24 hours.
        </Typography>
      </Box>
      <Button
        variant="contained"
        onClick={() => {
          track('send_message_click', { from_where: 'home' });
          navigate('/hub/messages');
        }}
        sx={{ flexShrink: 0, width: { xs: '100%', md: 'auto' }, px: 3 }}
      >
        Send Message
      </Button>
    </Box>
  );
}

export default TrainerContactBanner;
